var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWinicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#1D3F36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.21823 6.34375C8.70625 6.34375 8.22814 6.59962 7.94415 7.02562L4.80358 11.7365C4.61131 12.0249 4.58832 12.3942 4.74333 12.7042C6.46192 16.1414 8.85028 19.2003 11.768 21.7013L13.2999 23.0143C13.7027 23.3596 14.2971 23.3596 14.7 23.0143L16.2319 21.7013C19.1496 19.2003 21.538 16.1414 23.2565 12.7042C23.4116 12.3942 23.3886 12.0249 23.1963 11.7365L20.0557 7.02562C19.7717 6.59962 19.2936 6.34375 18.7817 6.34375H9.21823ZM9.03621 7.75366C9.07679 7.6928 9.14509 7.65625 9.21823 7.65625H11.2656L9.58983 11.678C9.55123 11.7706 9.5221 11.8662 9.50246 11.9632C8.88661 11.9174 8.27128 11.8621 7.65669 11.7974L6.42669 11.6679L9.03621 7.75366ZM6.36876 12.9816C7.93799 15.8603 10.0101 18.4375 12.489 20.5898L9.75422 13.2971C9.00843 13.2458 8.26333 13.181 7.5193 13.1027L6.36876 12.9816ZM11.1866 13.3789L13.9999 20.881L16.8132 13.3789C14.9387 13.4642 13.0612 13.4642 11.1866 13.3789ZM18.2457 13.2971L15.5109 20.5898C17.9898 18.4374 20.0619 15.8603 21.6311 12.9816L20.4806 13.1027C19.7365 13.181 18.9915 13.2458 18.2457 13.2971ZM21.5732 11.6679L20.3432 11.7974C19.7286 11.8621 19.1133 11.9174 18.4974 11.9632C18.4778 11.8662 18.4487 11.7706 18.4101 11.678L16.7343 7.65625H18.7817C18.8548 7.65625 18.9231 7.6928 18.9637 7.75366L21.5732 11.6679ZM17.1427 12.0488C15.0489 12.1575 12.951 12.1575 10.8572 12.0488L12.6874 7.65625H15.3125L17.1427 12.0488Z",
    fill: "#37C976"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinicon);
export default __webpack_public_path__ + "static/media/winicon.97f67fc2bbc58c20d3a33db10bcdbba6.svg";
export { ForwardRef as ReactComponent };